var _path, _g, _path2, _g2, _path3, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIlustraCopiar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 299 299",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_139_5175",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 299,
    height: 299
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0L299 0L299 299L0 299L0 0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_139_5175)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M264.459 149.426C264.459 212.657 213.201 263.914 149.97 263.914C86.7402 263.914 35.481 212.657 35.481 149.426C35.481 86.1955 86.7402 34.9374 149.97 34.9374C213.201 34.9374 264.459 86.1955 264.459 149.426Z",
    fill: "#FFF8C6"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_139_5175",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 34,
    width: 230,
    height: 230
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.481 149.426C35.481 212.657 86.7391 263.914 149.97 263.914C213.201 263.914 264.459 212.657 264.459 149.426C264.459 86.1953 213.201 34.9371 149.97 34.9371C86.7391 34.9371 35.481 86.1953 35.481 149.426",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_139_5175)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M289.966 149.836C289.966 218.914 227.457 274.914 150.348 274.914C73.2392 274.914 10.7295 218.914 10.7295 149.836C10.7295 80.7574 73.2392 24.7589 150.348 24.7589C227.457 24.7589 289.966 80.7574 289.966 149.836Z",
    fill: "#E6E7E8"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_139_5175",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 299,
    height: 299
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0L299 0L299 299L0 299L0 0Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_139_5175)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133.239 97.4296L194.323 97.4296V85.7957C194.314 82.5859 191.715 79.9855 188.506 79.9772L98.3317 79.9772V109.066C98.3317 112.279 95.7282 114.882 92.5153 114.882H60.5171L60.5171 225.418C60.5265 228.627 63.1268 231.226 66.3356 231.237H95.423L95.423 132.336L133.239 97.4296Z",
    fill: "#FFE0BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.3317 109.066V79.9772L60.5171 114.882H92.5143C95.7272 114.882 98.3317 112.279 98.3317 109.066Z",
    fill: "#F7A692"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.41 97.4297L133.239 97.4297V126.518C133.239 129.731 130.633 132.336 127.42 132.336H95.4229L95.4229 242.871C95.4333 246.081 98.0315 248.68 101.24 248.688L223.41 248.688C226.619 248.68 229.219 246.081 229.229 242.871L229.229 103.247C229.22 100.038 226.619 97.4401 223.41 97.4297Z",
    fill: "#FFE8CB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.421 132.335C130.633 132.335 133.238 129.731 133.238 126.519V97.4296L95.4233 132.335H127.421Z",
    fill: "#F7A692"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.239 248.689H223.411C226.624 248.689 229.229 246.083 229.229 242.871V158.781C213.338 202.302 177.706 235.679 133.239 248.689Z",
    fill: "#FFE0BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.959 175.968H118.693C117.087 175.968 115.785 174.666 115.785 173.06C115.785 171.453 117.087 170.151 118.693 170.151H205.959C207.565 170.151 208.867 171.453 208.867 173.06C208.867 174.666 207.565 175.968 205.959 175.968Z",
    fill: "#F37859"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.959 193.422H118.693C117.087 193.422 115.785 192.12 115.785 190.513C115.785 188.907 117.087 187.603 118.693 187.603H205.959C207.565 187.603 208.867 188.907 208.867 190.513C208.867 192.12 207.565 193.422 205.959 193.422Z",
    fill: "#F37859"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.959 210.874H118.693C117.087 210.874 115.785 209.572 115.785 207.966C115.785 206.359 117.087 205.057 118.693 205.057H205.959C207.565 205.057 208.867 206.359 208.867 207.966C208.867 209.572 207.565 210.874 205.959 210.874Z",
    fill: "#F37859"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.959 228.327H118.693C117.087 228.327 115.785 227.024 115.785 225.418C115.785 223.811 117.087 222.509 118.693 222.509H205.959C207.565 222.509 208.867 223.811 208.867 225.418C208.867 227.024 207.565 228.327 205.959 228.327Z",
    fill: "#F37859"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.959 158.515H141.964C140.358 158.515 139.056 157.213 139.056 155.606C139.056 154 140.358 152.699 141.964 152.699H205.959C207.565 152.699 208.867 154 208.867 155.606C208.867 157.213 207.565 158.515 205.959 158.515Z",
    fill: "#F37859"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.329 158.515H118.693C117.087 158.515 115.786 157.213 115.786 155.606C115.786 154 117.087 152.699 118.693 152.699H130.329C131.936 152.699 133.238 154 133.238 155.606C133.238 157.213 131.936 158.515 130.329 158.515Z",
    fill: "#F37859"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.223 39.4598C261.223 48.2943 254.061 55.4568 245.227 55.4568C236.391 55.4568 229.229 48.2943 229.229 39.4598C229.229 30.6252 236.391 23.4638 245.227 23.4638C254.061 23.4638 261.223 30.6252 261.223 39.4598Z",
    fill: "#A6A8AB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.0605 46.2039C99.0605 51.7328 103.557 56.2292 109.086 56.2292C114.615 56.2292 119.111 51.7328 119.111 46.2039C119.111 40.675 114.615 36.1785 109.086 36.1785C103.557 36.1785 99.0605 40.675 99.0605 46.2039ZM102.186 46.2039C102.186 42.3992 105.281 39.304 109.086 39.304C112.891 39.304 115.986 42.3992 115.986 46.2039C115.986 50.0086 112.891 53.1038 109.086 53.1038C105.281 53.1038 102.186 50.0086 102.186 46.2039Z",
    fill: "#A0A0A0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M208.347 69.0353C208.347 71.693 210.509 73.8547 213.167 73.8547C215.825 73.8547 217.987 71.693 217.987 69.0353C217.987 66.3766 215.825 64.2148 213.167 64.2148C210.509 64.2148 208.347 66.3766 208.347 69.0353ZM209.389 69.0353C209.389 66.9517 211.084 65.2567 213.167 65.2567C215.25 65.2567 216.945 66.9517 216.945 69.0353C216.945 71.1179 215.25 72.813 213.167 72.813C211.084 72.813 209.389 71.1179 209.389 69.0353Z",
    fill: "#A0A0A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.2992 199.381C52.2992 204.009 48.5466 207.761 43.9188 207.761C39.2911 207.761 35.5396 204.009 35.5396 199.381C35.5396 194.753 39.2911 191.002 43.9188 191.002C48.5466 191.002 52.2992 194.753 52.2992 199.381Z",
    fill: "#A6A8AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.853 21.0137C149.853 23.9953 147.436 26.4124 144.454 26.4124C141.473 26.4124 139.055 23.9953 139.055 21.0137C139.055 18.032 141.473 15.615 144.454 15.615C147.436 15.615 149.853 18.032 149.853 21.0137Z",
    fill: "#A6A8AB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.127 263.854C128.127 266.512 130.289 268.674 132.946 268.674C135.605 268.674 137.767 266.512 137.767 263.854C137.767 261.195 135.605 259.034 132.946 259.034C130.289 259.034 128.127 261.195 128.127 263.854ZM129.169 263.854C129.169 261.771 130.864 260.076 132.946 260.076C135.03 260.076 136.725 261.771 136.725 263.854C136.725 265.937 135.03 267.632 132.946 267.632C130.864 267.632 129.169 265.937 129.169 263.854Z",
    fill: "#A0A0A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.085 143.431C255.085 144.402 254.299 145.189 253.328 145.189C252.358 145.189 251.571 144.402 251.571 143.431C251.571 142.46 252.358 141.674 253.328 141.674C254.299 141.674 255.085 142.46 255.085 143.431Z",
    fill: "#A6A8AB"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIlustraCopiar);
export default __webpack_public_path__ + "static/media/ilustra-copiar.845e467c9037771463bbd89eaa7b8572.svg";
export { ForwardRef as ReactComponent };